import { render, staticRenderFns } from "./DiscountFlow.vue?vue&type=template&id=45f54572&scoped=true&"
import script from "./DiscountFlow.vue?vue&type=script&lang=js&"
export * from "./DiscountFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f54572",
  null
  
)

export default component.exports